import { Video } from 'components/common/subcomponents/Video';

export function VideoBase({ url: urlProp, file, autoPlay: autoPlayProp, loop: loopProp, ...props }) {
  const src = urlProp || file?.url;
  const autoPlay = autoPlayProp === 'true' || autoPlayProp === true;
  const loop = loopProp === 'true' || loopProp === true;

  return <Video {...props} src={src} autoPlay={autoPlay} loop={loop} />;
}
